const WarningBar = () => (
  <div className="block relative bg-transparent text-bionic-warningBarText text-center text-[12px] lg:text-[13px] px-3 py-1 w-screen opacity-0 mb-2">
    {/* <div className="block relative bg-bionic-warningBarBg text-bionic-warningBarText text-center text-[12px] lg:text-[13px] px-3 py-1 w-screen opacity-80 z-10"> */}
    Don’t invest unless you’re prepared to lose all the money you invest. This
    is a high-risk investment and you should not expect to be protected if
    something goes wrong.{' '}
    <a href="#" className="underline underline-offset-2 hover:text-white">
      Take 2 mins to learn more
    </a>
  </div>
);

export default WarningBar;
